import React, { ComponentPropsWithoutRef, FC } from 'react';
import cn from 'classnames';

const CloseButton: FC<ComponentPropsWithoutRef<'button'>> = (props) => (
  <button
    {...props}
    className={cn(
      'absolute right-15 flex items-center justify-center top-15 bg-none border-none z-30 text-grey-3',
      !props.disabled &&
        'cursor-pointer hover:text-grey-2 focus:text-grey-1 transition-all duration-100',
      props.disabled && 'cursor-default',
      'Close-Button',
    )}
    data-cy="close-button"
  >
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.13101 7.00005L13.1654 1.96565C13.4782 1.65285 13.4782 1.14725 13.1654 0.834454C12.8526 0.521654 12.347 0.521654 12.0342 0.834454L6.99981 5.86885L1.96541 0.834454C1.65261 0.521654 1.14701 0.521654 0.834209 0.834454C0.521409 1.14725 0.521409 1.65285 0.834209 1.96565L5.86861 7.00005L0.834209 12.0345C0.521409 12.3473 0.521409 12.8529 0.834209 13.1657C0.990209 13.3217 1.19501 13.4001 1.39981 13.4001C1.60461 13.4001 1.80941 13.3217 1.96541 13.1657L6.99981 8.13125L12.0342 13.1657C12.1902 13.3217 12.395 13.4001 12.5998 13.4001C12.8046 13.4001 13.0094 13.3217 13.1654 13.1657C13.4782 12.8529 13.4782 12.3473 13.1654 12.0345L8.13101 7.00005Z"
        fill="currentColor"
      />
    </svg>
  </button>
);

export default CloseButton;
